import React from "react";

const standards = [
  "ISO/IEC 27001",
  "EBIOS RM",
  "ISO/IEC 27005",
  "NIS 2",
  "RGPD / GDPR",
  "NIST CSF",
  "PCI-DSS",
  "MITRE ATT&CK",
  "ISO 22301",
  "ANSSI",
  "SOC 2",
  "OWASP",
];

export default function StandardsMarquee() {
  const loop = [...standards, ...standards];
  return (
    <section id="standards" className="relative py-16 md:py-20 border-y border-white/5 bg-[#080F0B]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12 mb-10 flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="font-mono text-xs text-emerald-400 mb-3 tracking-widest">
            // STANDARDS & RÉFÉRENTIELS
          </div>
          <h3 className="font-display text-2xl md:text-3xl font-semibold leading-tight max-w-2xl">
            Nous travaillons aux frontières des cadres
            <span className="italic text-emerald-400"> les plus exigeants.</span>
          </h3>
        </div>
        <div className="text-sm text-gray-500 max-w-xs">
          Une expertise transverse pour couvrir vos enjeux réglementaires,
          sectoriels et techniques.
        </div>
      </div>

      <div
        data-testid="standards-marquee"
        className="relative overflow-hidden"
        style={{
          maskImage:
            "linear-gradient(to right, transparent, black 8%, black 92%, transparent)",
          WebkitMaskImage:
            "linear-gradient(to right, transparent, black 8%, black 92%, transparent)",
        }}
      >
        <div className="flex gap-4 animate-marquee whitespace-nowrap will-change-transform">
          {loop.map((s, i) => (
            <div
              key={i}
              className="shrink-0 px-6 py-3.5 rounded-full border border-[#1A2E22] bg-[#0C1410] text-gray-300 font-mono text-sm hover:border-emerald-500/40 hover:text-emerald-400 transition-colors"
            >
              <span className="text-emerald-400 mr-2">▸</span>
              {s}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
